import { AbstractFrameTrigger } from '@studiometa/ui';

/**
 *
 */
export class FrameSelect extends AbstractFrameTrigger {
  static config = {
    ...AbstractFrameTrigger.config,
    name: 'FrameSelect',
    options: {
      ...AbstractFrameTrigger.config.options,
      prepend: {
        type: String,
        default: '',
      },
    },
  };

  /**
   * The URL to use for the request.
   * @returns {URL}
   */
  get url() {
    return new URL(`${this.$options.prepend}${this.$el.value}`, window.location.origin);
  }

  /**
   * Trigger on change.
   */
  onChange() {
    this.trigger();
  }
}
